// Single source of truth for auth token + persisted user snapshot.
// Kept framework-agnostic so BaseApiClient (non-React) can read the token.
const TOKEN_KEY = 'cc_token';
const USER_KEY = 'cc_user';

export const tokenStorage = {
  getToken() {
    try { return localStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
  },
  setToken(token) {
    try {
      if (token) localStorage.setItem(TOKEN_KEY, token);
      else localStorage.removeItem(TOKEN_KEY);
    } catch { /* ignore */ }
  },
  getUser() {
    try {
      const raw = localStorage.getItem(USER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  },
  setUser(user) {
    try {
      if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
      else localStorage.removeItem(USER_KEY);
    } catch { /* ignore */ }
  },
  clear() {
    try {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    } catch { /* ignore */ }
  },
};
